export enum DomainStatus {
  WaitingToAddDNS = "WaitingToAddDNS",
  WaitingToVerifyDNS = "WaitingToVerifyDNS",
  WaitingToInstall = "WaitingToInstall",
  Working = "Working",
  Error = "Error"
};
